import { v4 as uuidV4 } from "uuid";
export const getUniqId = () => {
    return uuidV4();
};